import React from 'react'
import classNames from 'classnames'

export type NameProps = React.ComponentPropsWithoutRef<'span'>

export const Name = ({ className, ...rest }: NameProps) => (
  <span className={classNames('testimonial-card__name', className)} {...rest} />
)
